import FormattedMessage from 'I18n/components/FormattedMessage';
//@ts-expect-error CollectedForms missing types
import CollectedFormSidePanel from 'FormsUI/components/dashboard/panels/CollectedFormSidePanel';
import { PROPERTIES } from 'FormsUI/components/dashboard/frameworkTable/constants';
import { getPropertyValue } from 'framework-listing-lib/utils/crmObject';
import FormTypes from 'forms-utils-lib/constants/formDefinition/FormTypes';
import { jsx as _jsx } from "react/jsx-runtime";
const viewNonHSInformationAction = {
  id: 'view-non-hs-information',
  name: /*#__PURE__*/_jsx(FormattedMessage, {
    message: "dashboard.table.collectedForms.actions.viewInformation"
  }),
  actionGroup: 2,
  orderInActionGroup: 0,
  displayPermissions: {
    custom: ({
      crmObject,
      nonCrmObject
    }) => {
      const formType = getPropertyValue(crmObject, PROPERTIES.FORM_TYPE);
      return Boolean(nonCrmObject && nonCrmObject.type === 'DASHBOARD') && formType === FormTypes.CAPTURED;
    }
  },
  ModalOrPanel: ({
    crmObject,
    onClose
  }) => {
    const formGuid = getPropertyValue(crmObject, PROPERTIES.FORM_ID) || '';
    return /*#__PURE__*/_jsx(CollectedFormSidePanel, {
      guid: formGuid,
      onClose: onClose
    });
  }
};
export default viewNonHSInformationAction;